import { render } from "./subSettings.vue?vue&type=template&id=8abd8eb8"
import script from "./subSettings.vue?vue&type=script&lang=js"
export * from "./subSettings.vue?vue&type=script&lang=js"

import exportComponent from "C:\\WSS-BuildAgent\\_work\\5\\s\\Sureload Admin\\sureload-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__